import React, { useContext } from "react";
import TablePage from "../core/TablePage";
import { PersonelContext } from "../data/personel/PersonelContext";

const ShelfPage = ({ warehouse, onAdd, onEdit, onDelete }) => {
  const { personelList } = useContext(PersonelContext);

  const columns = [
    { field: "id", header: "ID", hideInFilter: "true" },
    { field: "name", header: "Raf Adı" },
    { field: "status", header: "Durum" },
    {
      header: "Personel",
      body: (rowData) => {
        const person = personelList.find(p => p.id === rowData.personelId);
        return person ? person.fullName : "-";
      },
    },
    {
      header: "İşlemler",
      hideInFilter: "true",
      body: (rowData) => (
        <div className="flex gap-2">
          <button className="btn btn-sm btn-primary" onClick={() => onEdit(rowData)}>
            Düzenle
          </button>
          <button className="btn btn-sm btn-danger" onClick={() => onDelete(rowData.id)}>
            Sil
          </button>
        </div>
      ),
    },
  ];

  return (
    <TablePage
      title={`Raf Listesi - ${warehouse.name}`}
      subTitle="Raf ekleyebilir, düzenleyebilir veya silebilirsiniz."
      columns={columns}
      data={warehouse.shelves || []}
      defaultRows={5}
      onAdd={onAdd}
      showHeader={false}
      modalFilterStyle={true}
    />
  );
};

export default ShelfPage;
